import { Flex, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import colors from "../../../utils/colors";

interface IProps {
  setPeriod: React.Dispatch<React.SetStateAction<any>>
}
const AppointmentsHeader = ({setPeriod}: IProps) => {
  const [active, setActive] = useState(0);
  const sections = ["Past year", "Past month", "Past week"];
  return (
    <Flex flex={1} justifyContent={"space-between"} padding={"10px 30px 20px 20px"} alignItems={"center"}>
      <Text
        fontWeight={700}
        fontFamily={"lato"}
        fontSize={"16px"}
        color={colors.dark}
      >
        {"Appointments overview"}
      </Text>

      <Flex gap={"4px"} p={"8px"}>
        {sections.map((section, index) => (
          <Text
            fontWeight={400}
            fontFamily={"lato"}
            fontSize={"12px"}
            color={index === active ? colors.white : colors.dark}
            p={"8px"} borderRadius={"4px"}
            backgroundColor={index === active ? colors.primary : colors.white}
            cursor={"pointer"}
            _hover={active !== index ? {backgroundColor: colors.lightGrey} : {}}
            onClick={()=> {setActive(index); setPeriod(section?.split(" ")[1])}}
          >
            {section}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
};

export default AppointmentsHeader;
